import { Http } from "@/util";

export function listEvaluations(param) {
  return Http.post("/admin/evaluation/list", param);
}

// 查询司机差评
export function getBadEvaluationList(param) {
  return Http.post("/admin/evaluation/get/bad/list", param);
}

// 订单项免责
export function orderItemAppealed(orderId, type) {
  return Http.get("/admin/evaluation/order_item/appeal", { orderId, type });
}
